//react
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

//redux
import { Provider } from "react-redux";

//tools
import { $static } from "./tools/helpers";
import { $getLanguage } from "./tools/helpers";
import { initializeStore } from "./store.js";

//components
import App from "./App.jsx";

//icons
import AiChatAvatar from "./assets/ai-chat-avatar.svg";

//styles
import "./index.css";

// i18n
import i18n from "../i18n.js";

const AI_CHAT_ROOT_KEY = "__cng_ai_chat_root";
const AI_CHAT_ROOT_ELEMENT_KEY = "__cng_ai_chat_root_element";

function setAiChatLang(lang) {
	i18n.changeLanguage(lang);
}

function renderApp(elementId = "cng_ai_chat") {
	const element = document.getElementById(elementId);
	if (!element) {
		console.error(`Element with id "${elementId}" not found`);
		return null;
	}

	let mainAppLanguage = $getLanguage()
	if (mainAppLanguage) {
		setAiChatLang(mainAppLanguage);
	}

	const externalStore = initializeStore();
	if (!externalStore) {
		return null;
	}

	let root = window[AI_CHAT_ROOT_KEY] || null;
	const currentRootElement = window[AI_CHAT_ROOT_ELEMENT_KEY] || null;

	if (root && currentRootElement !== element) {
		root.unmount();
		root = null;
	}

	if (!root) {
		root = createRoot(element);
		window[AI_CHAT_ROOT_KEY] = root;
	}

	window[AI_CHAT_ROOT_ELEMENT_KEY] = element;
	
	root.render(
		<StrictMode>
			<Provider store={externalStore}>
				<App />
			</Provider>
		</StrictMode>
	);
	return root;
}

if (typeof window !== "undefined") {
	window.renderCngAiChat = renderApp;
	window.setAiChatLang = setAiChatLang;
	window.reconnectAiChat = () => window.__cng_websocket_manager?.reconnect?.();

	const aiChatAvatarHeadingSection = document.getElementById("ai_chat_avatar_heading_section");

	if (aiChatAvatarHeadingSection) {
		let aiChatAvatarAttentionBlock = document.getElementById("cng_ai_chat_avatar_attention_block");
		if (!aiChatAvatarAttentionBlock) {
			aiChatAvatarAttentionBlock = document.createElement("div");
			aiChatAvatarHeadingSection.appendChild(aiChatAvatarAttentionBlock);
			aiChatAvatarAttentionBlock.id = "cng_ai_chat_avatar_attention_block";
			aiChatAvatarAttentionBlock.classList.add("cng_ai_chat_avatar_attention_block");
		}
		
		let aiChatAvatarDom = document.getElementById("cng_ai_chat_avatar");
		if (!aiChatAvatarDom) {
			aiChatAvatarDom = document.createElement("img");
			aiChatAvatarHeadingSection.appendChild(aiChatAvatarDom);
		}
		aiChatAvatarDom.id = "cng_ai_chat_avatar";
		aiChatAvatarDom.src = $static(AiChatAvatar);
		aiChatAvatarDom.alt = "AI Chat Avatar";

		// console.log("Rendering Check & Go AI Chat...");
	
		if (document.readyState === "loading") {
			document.addEventListener("DOMContentLoaded", () => renderApp());
		} else {
			renderApp();
		}
	}
}

export { renderApp, setAiChatLang };
